import React, { useEffect } from 'react';
const Navbar = React.lazy(() => import('./components/Navbar'));
const ContactUs = React.lazy(() => import('../../components/contactus/ContactUs'));
const Footer = React.lazy(() => import('./components/Footer'));
import { scrollToTop } from '../../utils/funtions';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { getYachtsThunk, initialStateYacht } from '../../store/slices/catalogs/yacht.slice';

const ContactUsPage = () => {

  const dispatch = useDispatch();
  const yachtState = useSelector(state => state.yachts);

  useEffect(() => {
    scrollToTop();
    dispatch(getYachtsThunk())
    return () => {
      dispatch(initialStateYacht())
    }
  }, [])

  return (
    <div className='bg-white'>
      <Helmet>
        <title>Contact Us | Book Your Galapagos Cruise – Rolf Wittmer</title>
        <meta name="description" content="Get in touch with our team to plan your once-in-a-lifetime Galapagos adventure on board a first-class sustainable yacht." />
      </Helmet>
      <Navbar yachtState={yachtState.yachts} />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default ContactUsPage;